import $ from "jquery";

/**
 * Focus backdrop click
 */
$("body").on("click tap", "[data-close-focus-backdrop]", function (e) {
    releaseFocus();
});

function releaseFocus() {
    $("html").removeClass("s_user-clicked-menu");
    $("body").removeClass("s_is-open_side-panel");
    $("body").removeClass("s_is-open_search-overlay");

    $("#side-panel").html("");
}

$(document).on("keydown", function (e) {
    // console.log(e);
    if (e.code === "Escape") {
        releaseFocus();
    }
});
